export async function to(promise) {
  try {
    const response = await promise
    return [null, response]
  } catch (error) {
    return [error, null]
  }
}
